<template>
  <div class="tile is-parent">
    <article class="tile is-child box">
      <p class="title">横滑模块</p>
      <el-tabs v-model="activeName">
        <el-tab-pane label="内容管理" name="contentManager">
          <div class="margin-top-left-20">
            <div class="block width-1 fleft">
              <span class="button is-success" @click="addSideslip">新增</span>
            </div>
            <div v-if="sideslipList.count > 0" class="clearfix fright" style="margin-bottom: 20px;">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="sideslipList.page"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="sideslipList.count">
              </el-pagination>
            </div>
            <table class="table is-bordered is-fullwidth">
              <thead>
              <tr>
                <th>ID</th>
                <th>banner</th>
                <td>标题&统计</td>
                <th>状态</th>
                <th>排序号</th>
                <th>操作</th>
              </tr>
              </thead>
              <tbody>
              <tr class="list-cell" v-for="(item, index) in sideslipList.list">
                <td>
                  {{item.contentId}}
                  <span class="tag is-success" v-if="item.statusTag==0">开放中</span>
                  <span class="tag is-black" v-if="item.statusTag==1">未开始</span>
                  <span class="tag is-light" v-if="item.statusTag==2">已结束</span>
                  <span class="tag is-light" v-if="item.statusTag==3">已关闭</span>
                </td>
                <td>
                  <image-component :image='item.image' :width="150"></image-component>
                </td>
                <td>
                  <p class="title content-title">标题:{{item.title}}</p>
                  <p class="">点击数:{{formatStats(item.stats)}}</p>
                </td>
                <td>
                  <div class="time block">{{item.startTime | formatDate('yyyy-MM-dd hh:mm:ss')}} ~ {{item.endTime | formatDate('yyyy-MM-dd hh:mm:ss')}} </div>
                </td>
                <td>
                  <p class="block">排序号</p>
                  <input class="input width-1" v-model="item.sort" @change="sortChange(item)">
                </td>
                <td>
                  <p class='block'>
                    <span class="button is-info" @click="goEdit(item)">编辑</span>
                  </p>
                  <p>
                    <span class="button is-danger" @click="deleteClick(item,index)">删除</span>
                  </p>
                </td>
              </tr>
              </tbody>
            </table>
            <div v-if="sideslipList.count > 0" class="clearfix fright">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="sideslipList.page"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="sideslipList.count">
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="模块设置" name="moduleSetting">
          <div class="margin-top-left-20">
            <p class="title"><input type="checkbox" v-model="module.showTitle">是否展示标题</p>
            <div class="block width-2">
              <input class="input" type="text" v-model="module.title">
            </div>
            <p class="title">显示 "查看全部" <i>(客户端不需要展示则留空)</i></p>
            <div class="block width-2">
              <input class="input" type="text" v-model="module.moreTitle">
            </div>
            <p class="title">"查看全部" 跳转链接</p>
            <div class="block cyzs-w-400">
              <custom-link :link='module.moreLink' @update:link="val => {module.moreLink = val }"></custom-link>
            </div>
            <p class="block title">显示状态</p>
            <p class="block">
              <input class="radio" type="radio" v-model="module.status" value="1">开启
              <input class="radio" type="radio" v-model="module.status" value="0">关闭
            </p>
            <div class="slider-wrap">
              <p class="title">
                <span>与上一模块间距（px）</span>
                <el-tooltip class="item" effect="dark" content="填写的数值请以 750px宽度的设计稿像素为标准" placement="top">
                  <span class='cursor-point'><i class='fa fa-question-circle'></i></span>
                </el-tooltip>
              </p>
              <p>
                <el-slider v-model="module.marginTop" :max="400" :show-input="true"></el-slider>
              </p>
            </div>
            <div class="slider-wrap">
              <p class="title">
                <span>水平间距（px）</span>
                <el-tooltip class="item" effect="dark" content="填写的数值请以 750px宽度的设计稿像素为标准" placement="top">
                  <span class='cursor-point'><i class='fa fa-question-circle'></i></span>
                </el-tooltip>
              </p>
              <p>
                <el-slider v-model="module.marginLeft" :max="400" :show-input="true"></el-slider>
              </p>
            </div>
            <div class="slider-wrap">
              <p class="title">
                <span>图片高度（px）</span>
                <el-tooltip class="item" effect="dark" content="填写的数值请以 750px宽度的设计稿像素为标准" placement="top">
                  <span class='cursor-point'><i class='fa fa-question-circle'></i></span>
                </el-tooltip>
              </p>
              <p>
                <el-slider v-model="module.moduleHeight" :max="400" :show-input="true"></el-slider>
              </p>
            </div>
            <div v-if="routerName == 'discovery'" class="slider-wrap">
              <div class="title">是否展示底部分割线</div>
              <div class="block">
                <label><input type="radio" :value="1" v-model="module.isShowTopLine" name="isShowTopLine">是</label>
                <label><input type="radio" :value="0" v-model="module.isShowTopLine" name="isShowTopLine">否</label>
              </div>
            </div>
          </div>
          <div class="margin-top-left-20">
            <button class="button is-success" @click="saveModuleClick">保存</button>
            <button v-if="module.status == 2" class="button is-info" @click="archiveClick(1)">还原归档</button>
            <button v-else="" class="button is-info" @click="archiveClick(0)">归档模块</button>
          </div>
        </el-tab-pane>
      </el-tabs>
  </article>
  </div>
</template>

<script type="text/babel">
  import CustomLink from 'COMMON/DefinedLink';
  import { mapState, mapActions } from 'vuex';

  export default {
    name:"sideslip",
    components:{ CustomLink },
    data(){
      return{
        activeName: 'contentManager',
        moduleSettingSelected: false,
        pageSize: 10,
        selectedIndex:0,
        module:{
          title:"",
          showTitle:1,
          moreTitle:"",
          moreLink:"",
          status:1,
          marginTop:48,
          marginLeft:40,
          moduleHeight:40,
		  isShowTopLine: 1
        },
        sideslipList:{
          page:1,
          count:0,
          list:[]
        },
		routerName: ''
	  }
    },
    computed: {
      marginTopPer () {
        return this.module.marginTop + 'px'
      },
      marginLeftPer () {
        return this.module.marginLeft + 'px'
      },
      moduleHeightPer(){
        return this.module.moduleHeight + 'px'
      },
      ...mapState({
        currentFashionMenu: state => state.currentFashionMenu
      }),
    },
    watch: {
      currentFashionMenu: {
        handler(val) {
          this.moduleSettingSelected = !this.currentFashionMenu.moduleId;
          this.module.moduleId = this.currentFashionMenu.moduleId;
          if (this.moduleSettingSelected) {
            this.activeName = 'moduleSetting'
            this.module.title = "";
            this.module.showTitle = 1;
            this.module.moreTitle = "";
            this.module.moreLink = "";
            this.module.status = 1;
            this.module.marginTop = 48;
            this.module.marginLeft = 40;
            this.module.moduleHeight = 40;
            this.module.isShowTopLine = 1;
            this.sideslipList.page = 1;
            this.sideslipList.count = 0;
            this.sideslipList.list = [];
          } else {
            this.activeName = 'contentManager'
            this.getInitList();
            this.getInitModule();
          }
          if(this.$route.query.type == 0){//市集默认50,发现默认24,0市集
            this.module.marginTop = 100;
          }
        },
        deep: true
      }
    },
    mounted() {
      if (this.$route.query.page) {
        this.sideslipList.page = this.$route.query.page*1;
      }
      if (this.currentFashionMenu.moduleType == -1) {
        this.setCurrentFashionMenuByVuex({
          type: this.$route.query.type,
          moduleType:this.$route.query.moduleType,
          moduleId:this.$route.query.moduleId,
          moduleName:this.$route.query.moduleName
        })
      } else {
        this.moduleSettingSelected = !this.currentFashionMenu.moduleId;
        if (this.moduleSettingSelected) {
          this.activeName = 'moduleSetting'
        } else {
          this.activeName = 'contentManager'
          this.getInitList();
        }
        this.getInitModule();
      }
      if(this.$route.query.type == 0){//市集默认50,发现默认24,0市集
        this.module.marginTop = 50;
      }
    },
    methods: {
      handleCurrentChange(page) {
        if (this.sideslipList.page !== page) {
          this.sideslipList.page = page
          this.getInitList();
        }
        
      },
      /**
       * 获取内容列表
       * */
      getInitList(){
        if(!this.currentFashionMenu.moduleId){
          return
        }
        let params = {
          type:this.currentFashionMenu.type,
          moduleId:this.currentFashionMenu.moduleId,
          page:this.sideslipList.page,
          pageSize: this.pageSize,
        }
        HttpRequest.get("/admin.php?method=fashion.getModuleContentList",params,true).then((response)=>{
          this.sideslipList.list = response.data.list;
          this.sideslipList.count = response.data.count;
        })
      },
      /**
       * 获取模块信息
       * */
      getInitModule(){
        if(!this.currentFashionMenu.moduleId){
          return
        }
        HttpRequest.get("/admin.php?method=fashion.getModule",{ moduleId:this.currentFashionMenu.moduleId},true).then((response)=>{
          this.module = response.data;
          this.module.marginTop = response.data.marginTop*2;
          this.module.marginLeft = response.data.marginLeft*2;
          this.module.moduleHeight = response.data.moduleHeight*2;
          this.module.isShowTopLine = response.data.isShowTopLine ? 1 : 0;
        })
      },
      /**
       * 排序修改保存
       * */
      sortChange(item){
        let params ={
          contentId:item.contentId,
          sort:item.sort
        }
        HttpRequest.get("/admin.php?method=fashion.doSaveModuleContentSort",params,true).then((response)=>{
          if(response.data.success == 1){
            this.$message("修改成功!") ;
          }
        })
      },
      /**
       * 删除
       * */
      deleteClick(item,index){
        if (confirm('是否确定删除?')) {
          HttpRequest.get("/admin.php?method=fashion.deleteModuleContent",{contentId:item.contentId},true).then((response)=>{
            if(response.data.success == 1){
              this.$message("删除成功!");
              this.sideslipList.list.splice(index,1);
            }
          })
        }
      },
      /**
       * 保存模块
       * */
      saveModuleClick(){
        //标题填写后链接必填
        if(this.module.moreTitle){
          if(!this.module.moreLink){
            return
          }
        }else{
          this.module.moreLink = "";
        }
        if(this.module.showTitle && !this.module.title){
          this.$message("请填写模块名称!");
          return
        }
        let params = Object.assign({},this.module, this.currentFashionMenu);
        params.showTitle = (this.module.showTitle == true) ? 1:0;
        params.isShowTopLine = (this.module.isShowTopLine == true) ? 1:0;
        params.marginTop = params.marginTop/2;
        params.marginLeft = params.marginLeft/2;
        params.moduleHeight = params.moduleHeight/2;
        HttpRequest.post("/admin.php?method=fashion.doSaveModule",params,true).then((response)=>{
          setTimeout(() => {
            this.commitFashionMenuUpdate(true)
          }, 2000)
          this.$message("保存成功!");
        })
      },
      /**
       * 归档保存
       * */
      archiveClick(type) {
        let params = {
          moduleId: this.currentFashionMenu.moduleId,
          actionType: type,//0归档,1恢复
        }
        HttpRequest.post("/admin.php?method=fashion.archiveModule", params, true).then((response) => {
          if (response.data.success == 1) {
            setTimeout(() => {
              this.commitFashionMenuUpdate(true)
            }, 2000)
            this.$message("保存成功!");
          } else {
            this.$message('接口错误,请联系管理员');
          }
        }, (error) => {

        });
      },
      /**
       * 格式化统计字段
       * */
      formatStats(stats){
        return stats.join("/");
      },
      addSideslip() {
        let _query = {
          type:this.currentFashionMenu.type,
          contentId:0,
          moduleId:this.currentFashionMenu.moduleId,
        }
        if (this.currentFashionMenu.moduleId) {
          this.$router.push({
            name: 'sideslipEdit',
            query: _query
          })
        } else {
          this.$message('请先完成模块设置')
        }
      },
      goEdit(item) {
        this.$router.push({
          name: 'sideslipEdit',
          query: Object.assign({ page: this.sideslipList.page },{ type:this.currentFashionMenu.type,contentId:item.contentId,moduleId:this.currentFashionMenu.moduleId,moduleName:this.currentFashionMenu.moduleName})
        })
      },
      ...mapActions([
        'commitFashionMenuUpdate', 'setCurrentFashionMenuByVuex'
      ]),
    }
  }
</script>

<style lang="less">
  .custom-link-wrap{
    border-radius: 6px;
    border: 1px solid #00d1b2;
    width: 300px;
    padding: 20px;
  }
  .margin-top-left-20{
    margin: 20px 0 0 20px;
  }
  .slider-wrap{
    width: 400px;
    margin-top: 40px;
    .tooltip-value{
      margin-left: 20px;
    }
    .input-slider{
      margin-top: 30px;
    }
  }
  .content-title{
    white-space: normal;
    line-height: 1.2;
    display: inline-block;
  }
</style>
